import React from 'react'
import "./spinner.css"

function spinner() {
  return (
  <div className="spinner"><div className = "spin"></div></div>
    
  )
}

export default spinner